import { AxiosResponse } from 'axios'
import { normalize, schema } from 'normalizr'
import { TripStages, TripStatuses } from '../constants/trip-statuses'
import {
  IActiveTripResponse,
  IActiveTripResponseV2,
  ISimpleDriverDTO,
  IPagination,
  IProviderProductPricing,
  ITripHistoryObject,
  ITripRequestObject,
  ITripStatus,
  ITripFilters,
  IWaypointFilters,
  IUserTrips,
  IMapBound
} from '../types'
import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

class StationUserTrips {
  public async fetch(
    orgId: string | undefined,
    currentUserId: string
  ): Promise<{ total: number; items: IActiveTripResponseV2[] }> {
    if (!orgId && !currentUserId) {
      return { total: 0, items: [] }
    }

    const result = await serverApi.get<any>(`${Paths.stationUserTrips.fetchStationUserTrips}/${currentUserId}/${orgId}`)
    // if(orgId && currentUserId){
    //   const params = {
    //     riderId:'1fdb9f8a-95c2-40be-9d84-7537c3880173',
    //     organizationId:'b91b45de-2eac-4e3d-8e69-8849fb4995dd'
    //   }
    // const result = await serverApi.get<any>(`${Paths.tripsBaseUrl}/recent`,{params})
    // const result = await serverApi.get<any>(`${Paths.stationUserTrips.fetchStationUserTrips}/`,{params})

    console.log('result.data: ', result.data)
    return result.data
    // }else{
    //   return { total: 0, items: [] }
    // }
  }
}

const stationUserTrips = new StationUserTrips()

export { stationUserTrips }



// WEBPACK FOOTER //
// ./src/services/station-user-trips.ts